'use client'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import './styles.css'
import Box from '@mui/material/Box'
import Image from 'next/image'
import Link from 'next/link'
import { memo } from 'react'
import { getImageData } from '@/utilites/getImageData'
import { resolveHref } from '@/utilites/resolveHref'

const CARD_BOX_SX = {
    borderRadius: '30px',
    overflow: 'hidden',
    position: 'relative',
    height: 200,
}

interface Card {
    link?: string
    image?: string | Record<string, unknown>
}

interface SwiperV3Props {
    cards?: Card[]
}

const Index = ({ cards = [] }: SwiperV3Props) => {
    const normalizedCards = cards.map((item) => {
        const { src } = getImageData(item.image)
        return {
            ...item,
            image: src || '/img/img-160400.jpg',
        }
    })
    return (
        <Swiper
            modules={[Navigation]}
            navigation={true}
            loop={true}
            spaceBetween={10}
            className='mySwiper'
            breakpoints={{
                0: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
            }}
        >
            {normalizedCards.map((item, index) => (
                <SwiperSlide key={'cards' + index}>
                    <Box
                        component={Link}
                        href={resolveHref(item?.link)}
                        aria-label={`services works ${index}`}
                        sx={CARD_BOX_SX}
                    >
                        <Image
                            src={item?.image ||'/img/img-160400.jpg'}
                            alt={`services works ${index}`}
                            width={300}
                            height={300}
                            style={{ width: '100%', height:  300, objectFit: 'cover', objectPosition: 'center', borderRadius: '30px' }}
                        />
                    </Box>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default memo(Index)


